require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./calculators-loan-payment-calculator.json") })
        }
      }, "path---calculators-loan-payment-calculator");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---calculators-loan-payment-calculator!./.cache/json/calculators-loan-payment-calculator.json
// module id = 2015
// module chunks = 231608221292675